"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMediaGalleryLazy = exports.FdrMediaGallery = void 0;
const next_i18next_1 = require("next-i18next");
const nuka_carousel_1 = __importDefault(require("nuka-carousel"));
const react_1 = __importStar(require("react"));
const core_serving_bs_lazy_render_1 = require("@hotelplan/core.serving.bs-lazy-render");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const libs_hooks_dom_1 = require("@hotelplan/libs.hooks-dom");
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
const fdr_media_gallery_constants_1 = require("./fdr-media-gallery.constants");
const fdr_media_gallery_styles_1 = require("./fdr-media-gallery.styles");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const FdrMediaGallery = ({ items: rawItems, initialSlide: originalInitialSlide = 0, hasThumbnails = false, allowThumbnails = true, hasPreview = true, isShowIndex = true, wrapAround = true, leftArrowIcon = `chevron-long-left`, rightArrowIcon = `chevron-long-right`, galleryPreviewIcon = `gallery-preview`, initialSlideHeight, isPreviewMode, onChangeSlide, className, autoplay = false, autoplayInterval = 10000, keyboardNavigation = false, }) => {
    var _a;
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    const { width, height } = (0, libs_hooks_dom_1.useViewportSize)();
    const [initialSlide, setInitialSlide] = (0, react_1.useState)(originalInitialSlide);
    const [slide, setSlide] = (0, react_1.useState)(initialSlide);
    const { items, bigImages } = (0, react_1.useMemo)(() => {
        const mappedItems = [];
        const mappedImages = [];
        let imageIndex = 0;
        rawItems.forEach((item, index) => {
            const indexedItem = Object.assign({ mapIndex: -1 }, item);
            if (item.__typename === 'FdrImage') {
                mappedImages.push(Object.assign(Object.assign({}, indexedItem), { mapIndex: index, image: 'bigResized' in item ? Object.assign(Object.assign({}, item), { resized: item.bigResized }) : item }));
                indexedItem.mapIndex = imageIndex;
                imageIndex++;
                mappedItems.push(Object.assign(Object.assign({}, indexedItem), { title: item.alt }));
            }
            else {
                mappedItems.push(indexedItem);
            }
        });
        return {
            items: mappedItems,
            bigImages: mappedImages,
        };
    }, [rawItems]);
    const [isSwipeHintShown, , hideSwipeHint] = (0, libs_hooks_react_1.useToggleState)(true);
    const [isModalShowed, openModal, closeModal] = (0, libs_hooks_react_1.useToggleState)(false);
    const currentMediaItem = items[slide];
    const defaultSlideHeight = (0, react_1.useMemo)(() => {
        if (!mobile) {
            return fdr_media_gallery_constants_1.HEIGHT_DESKTOP;
        }
        else if (width > height) {
            return fdr_media_gallery_constants_1.HEIGHT_MOBILE_LANDSCAPE;
        }
        else if (width <= 375) {
            return fdr_media_gallery_constants_1.HEIGHT_MOBILE_SMALL;
        }
        else if (width < 550) {
            return fdr_media_gallery_constants_1.HEIGHT_MOBILE;
        }
        else if (width >= 550 && width <= 888) {
            return fdr_media_gallery_constants_1.HEIGHT_MOBILE_LARGE;
        }
        else {
            return fdr_media_gallery_constants_1.HEIGHT_MOBILE_TABLET;
        }
    }, [mobile, width, height]);
    const disableSlideInfo = (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'FdrAudio' ||
        (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'FdrVideo';
    const thumbnailWrapperRef = (0, react_1.useRef)(null);
    const thumbnailRefs = (0, react_1.useRef)([]);
    // Scroll the corresponding thumbnail into view
    (0, react_1.useEffect)(() => {
        if (thumbnailRefs.current[slide]) {
            thumbnailRefs.current[slide].scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
            });
        }
    }, [slide]);
    (0, react_1.useEffect)(() => {
        const thumbnailWrapper = thumbnailWrapperRef.current;
        if (mobile || !thumbnailWrapper)
            return;
        const onWheel = (e) => {
            e.preventDefault();
            if (e.deltaY === 0)
                return;
            thumbnailWrapper.scrollLeft += e.deltaY;
        };
        thumbnailWrapper.addEventListener('wheel', onWheel, { passive: false });
        return () => thumbnailWrapper.removeEventListener('wheel', onWheel);
    }, [mobile]);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(thumbnailWrapperRef, true);
    const handleKeyDown = (0, react_1.useCallback)((event) => {
        if (!keyboardNavigation || items.length < 2) {
            return;
        }
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setSlide(prevSlide => {
                if (wrapAround) {
                    return (prevSlide - 1 + items.length) % items.length;
                }
                return Math.max(0, prevSlide - 1);
            });
        }
        else if (event.key === 'ArrowRight') {
            event.preventDefault();
            setSlide(prevSlide => {
                if (wrapAround) {
                    return (prevSlide + 1) % items.length;
                }
                return Math.min(items.length - 1, prevSlide + 1);
            });
        }
    }, [items, wrapAround, keyboardNavigation]);
    (0, react_1.useEffect)(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    return (react_1.default.createElement(fdr_media_gallery_styles_1.FdrMediaGalleryWrapper, { preview: Boolean(isPreviewMode), className: className },
        react_1.default.createElement(fdr_media_gallery_styles_1.FdrMediaGalleryBody, { className: "media-gallery-body", onClick: isPreviewMode ? null : openModal },
            items.length == 1 ? (react_1.default.createElement(fdr_media_gallery_styles_1.FdrSingleMediaGalleryItem, { data: items[0], height: initialSlideHeight || defaultSlideHeight, lazy: false, className: "single-item" })) : isModalShowed ? null : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(nuka_carousel_1.default, { dragging: mobile, slideIndex: slide, afterSlide: nextSlide => {
                        setSlide(nextSlide);
                        onChangeSlide === null || onChangeSlide === void 0 ? void 0 : onChangeSlide(items[nextSlide], nextSlide);
                    }, wrapAround: wrapAround, onDragStart: hideSwipeHint, initialSlideHeight: initialSlideHeight || defaultSlideHeight, renderCenterLeftControls: ({ previousSlide }) => {
                        return (react_1.default.createElement("button", { "aria-label": t('mediaGallery.previousSlide'), onClick: event => {
                                event.stopPropagation();
                                event.preventDefault();
                                previousSlide();
                            } },
                            react_1.default.createElement(fdr_media_gallery_styles_1.FdrLeftChevron, { name: leftArrowIcon, enable: (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'FdrVideo' })));
                    }, renderCenterRightControls: ({ nextSlide }) => {
                        return (react_1.default.createElement("button", { "aria-label": t('mediaGallery.nextSlide'), onClick: event => {
                                event.stopPropagation();
                                event.preventDefault();
                                nextSlide();
                            } },
                            react_1.default.createElement(fdr_media_gallery_styles_1.FdrRightChevron, { name: rightArrowIcon, enable: (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) === 'FdrVideo' })));
                    }, renderBottomRightControls: () => {
                        if (!hasPreview || (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.__typename) !== 'FdrImage')
                            return null;
                        return (items.length !== 1 && (react_1.default.createElement(fdr_media_gallery_styles_1.FdrOpenPreviewButton, { className: "open-preview", onClick: openModal },
                            react_1.default.createElement(fdr_media_gallery_styles_1.FdrGalleryPreviewIcon, { name: galleryPreviewIcon }),
                            t('mediaGallery.openPreviewButton'))));
                    }, renderBottomCenterControls: null, autoplay: autoplay, autoplayInterval: autoplayInterval }, items.map((item, i) => {
                    const key = `${item.__typename}-${i}`;
                    return (react_1.default.createElement(fdr_media_gallery_styles_1.FdrGeneralMediaGalleryItem, { key: key, data: item, lazy: i > 0, loading: i === 0 ? 'eager' : 'lazy', className: "general-item" }));
                })))),
            isSwipeHintShown && items.length !== 1 && react_1.default.createElement(fdr_media_gallery_styles_1.FdrSwipeIcon, null)),
        isShowIndex && (react_1.default.createElement(fdr_media_gallery_styles_1.FdrSlideInfo, { className: `slide-info ${disableSlideInfo && 'disable'}` },
            typeof currentMediaItem !== 'undefined' &&
                'title' in currentMediaItem &&
                (currentMediaItem === null || currentMediaItem === void 0 ? void 0 : currentMediaItem.title) ? (react_1.default.createElement("span", { className: "slide-title", dangerouslySetInnerHTML: { __html: currentMediaItem.title } })) : null,
            react_1.default.createElement("span", { className: "slide-number" },
                slide + 1,
                " | ",
                items.length))),
        hasThumbnails && allowThumbnails && (react_1.default.createElement(fdr_media_gallery_styles_1.FdrThumbnails, { ref: thumbnailWrapperRef, className: "thumbnails" }, items.map((item, i) => (react_1.default.createElement(fdr_media_gallery_styles_1.FdrThumbnailItem, { key: i, ref: el => (thumbnailRefs.current[i] = el), className: `thumbnail-item ${slide === i && 'active'}` },
            react_1.default.createElement("button", { className: "thumbnail-button", onClick: () => setSlide(i) },
                react_1.default.createElement(fdr_media_gallery_styles_1.FdrThumbnailItemMedia, { data: item }))))))),
        hasPreview && (react_1.default.createElement(fdr_media_gallery_styles_1.FdrMediaGalleryPreviewModal, { label: t('mediaGallery.previewLabel'), show: isModalShowed, onClose: closeModal },
            react_1.default.createElement(exports.FdrMediaGallery, { items: bigImages, hasPreview: false, hasThumbnails: true, allowThumbnails: allowThumbnails, leftArrowIcon: leftArrowIcon, rightArrowIcon: rightArrowIcon, galleryPreviewIcon: galleryPreviewIcon, isPreviewMode: true, initialSlideHeight: defaultSlideHeight, initialSlide: (_a = items[slide]) === null || _a === void 0 ? void 0 : _a.mapIndex, onChangeSlide: changedSlide => setInitialSlide(changedSlide.mapIndex), autoplay: autoplay, autoplayInterval: autoplayInterval, keyboardNavigation: true })))));
};
exports.FdrMediaGallery = FdrMediaGallery;
exports.FdrMediaGalleryLazy = (0, core_serving_bs_lazy_render_1.withLazyHydrate)(exports.FdrMediaGallery, {
    whenVisible: true,
});
//# sourceMappingURL=fdr-media-gallery.js.map